import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { convertToDate } from '../../../../../../utils/helpers.utils';
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import Icons from '../../../../../icon';
import { ORDER_STATUS, CIRCUIT_STATUS } from "../../../../../../constants/external-constants";
import FormatDate from "../../../../../common/date/format-date.component";

export class PortOutDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    editRequest = (orderStatusId, endUserId, requestorId) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);
        const showUpdateRequestLink = this.props.history.location.pathname.match(/Inventory.*/) === null ? true : false;

        return editableRequest && isRequestOwner && showUpdateRequestLink;
    }

    render() {
        const {  data, openRequestModal } = this.props;
        const {Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId }} = data || {};
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                {this.editRequest(OrderStatusId, EndUserId, RequestorId) ?  
                          <Icons
                          customClassName="pen-to-square"
                          name="pen-to-square"
                          size="20px"
                          containerClass="icon-circle-plus-container"
                          onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                          labelValue={"Update Order Request"}
                          labelClass="order-detail-edit-label"                                                              
                        />

                        : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="capital_sr_number" />
                        </div>
                        <div className="sr-number-label">
                            {data.Order.ServiceRequestNumber}
                        </div>
                    </div>
                    {data.Order.IsRequestedInBehalf ?
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                        : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className={data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Subscription.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.PlanDetails.PlanName ?
                                    data.Subscription.PlanDetails.PlanName :
                                    <Translation translationKey="no_plan_available" />}</td>
                            </tr>
                            
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription && data.Subscription.SubscriptionDetailDevice ?
                                    data.Subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="port_out_request_details" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="port_out_date" /></td>
                                <td>
                                    <FormatDate date={data.Order.OrderDisconnectDate} />
                                </td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="port_out_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}